import { z } from "zod";

export const companyMemberInfoSchema = z.object({
    joined: z.string().datetime({ offset: true }),
    workedWithTeam: z.boolean().optional(),
    workedWithTeamYears: z.number().optional(),
});

export type CompanyMemberInfo = z.infer<typeof companyMemberInfoSchema>;
